import { useMemo } from 'react';
import { useUser, useWebSocket } from '../components/WebSocketContext';
import { createNavigationStorage } from '../Utils/navigationMemory';

export default function useNavigationStorage() {
  const { serverUrl } = useWebSocket();
  const { username, organizationId, isPublicAccess } = useUser();
  return useMemo(() => createNavigationStorage(serverUrl, {
    username, organizationId, isPublicAccess,
  }), [serverUrl, username, organizationId, isPublicAccess]);
}
